import React from 'react';
import { func, bool, string, shape } from 'prop-types';
import { RowContainer } from './DiscussionDetailsCard.styled';
import EditDiscussionCard from './EditDiscussionCard';
import AddDiscussionCard from './AddDiscussionCard';

const DiscussionDetailsCard = ({
  openDiscussionTopicModal,
  discussionTopic,
  showDiscussion,
  discussionPermission,
}) => {
  return (
    <RowContainer hasPadding={!discussionTopic}>
      {discussionTopic ? (
        <EditDiscussionCard
          showDiscussion={showDiscussion}
          discussionTopic={discussionTopic}
          openDiscussionTopicModal={openDiscussionTopicModal}
          discussionPermission={discussionPermission}
        />
      ) : (
        <AddDiscussionCard
          openDiscussionTopicModal={openDiscussionTopicModal}
          discussionPermission={discussionPermission}
        />
      )}
    </RowContainer>
  );
};

DiscussionDetailsCard.propTypes = {
  openDiscussionTopicModal: func.isRequired,
  discussionTopic: string,
  showDiscussion: bool,
  discussionPermission: shape({
    allowed: bool,
    message: string,
  }),
};

DiscussionDetailsCard.defaultProps = {
  discussionTopic: '',
  showDiscussion: false,
  discussionPermission: { allowed: true },
};

export default DiscussionDetailsCard;
